// Shared top-of-screen header. Ported (style-only) from
// designproject/files/screens-tree.jsx (`ScreenHeader`). Used by full-screen
// views like UndoFullScreen, DestructPreviewScreen, ProfileScreen, etc.

import type { JSX } from 'preact';
import { T, Icon } from '../tokens';

export interface ScreenHeaderProps {
  readonly title: string;
  readonly subtitle?: string;
  readonly onBack?: () => void;
  readonly trailing?: JSX.Element;
}

export function ScreenHeader({
  title,
  subtitle,
  onBack,
  trailing,
}: ScreenHeaderProps): JSX.Element {
  return (
    <div
      style={{
        padding: onBack ? '8px 16px 14px' : '10px 20px 14px',
        display: 'flex',
        alignItems: 'flex-end',
        gap: 10,
      }}
    >
      {onBack !== undefined && (
        <button
          type="button"
          onClick={onBack}
          aria-label="Назад"
          style={{
            width: 36,
            height: 36,
            borderRadius: 18,
            background: T.surface,
            border: `1px solid ${T.border}`,
            cursor: 'pointer',
            color: T.ink,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: 2,
            padding: 0,
          }}
        >
          <Icon name="chevL" size={18} />
        </button>
      )}
      <div style={{ flex: 1, minWidth: 0 }}>
        <div
          style={{
            fontSize: 22,
            fontWeight: 700,
            letterSpacing: -0.5,
            color: T.ink,
            lineHeight: 1.15,
          }}
        >
          {title}
        </div>
        {subtitle !== undefined && (
          <div
            style={{
              fontSize: 12.5,
              color: T.ink3,
              marginTop: 3,
              fontWeight: 500,
            }}
          >
            {subtitle}
          </div>
        )}
      </div>
      {trailing}
    </div>
  );
}
